export const TrackingEventsActionTypes = {
    API_RESPONSE_SUCCESS: '@@tracking-events/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@tracking-events/API_RESPONSE_ERROR',
    GET_ALL_TRACKING_EVENTS_REQUEST: '@@tracking-events/GET_ALL_TRACKING_EVENTS_REQUEST',
};
